import Image from "@/components/AppImage";
import type { ReviewData } from "@/types/content";

interface ReviewCardProps {
  data: ReviewData;
}

const ReviewCard = ({ data }: ReviewCardProps) => {
  const { title, desc, user_name, user_designation, avt, rating } = data;

  return (
    <div className="single-item">
      <ul className="d-flex star-area align-items-center">
        {[...Array(rating * 1)].map((_, i) => (
          <li key={i}>
            <i className="fas fa-star"></i>
          </li>
        ))}
      </ul>
      <h5>{title}</h5>
      <p>{desc}</p>
      <div className="profile d-flex align-items-center">
        <div className="left">
          <Image src={avt} alt="image" />
        </div>
        <div className="right">
          <h6>{user_name}</h6>
          <p>{user_designation}</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
